import React, { useRef } from "react";
import * as XLSX from "xlsx";
import { TransaparentButton } from "./Buttons";
import { Icon } from "@material-ui/core";

const ExcelImporter = ({ onImportData }) => {
  const fileInputRef = useRef(null);

  // Trigger file input click
  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  // Read and parse Excel file
  const handleImportFile = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const firstSheet = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheet];

      const jsonData = XLSX.utils.sheet_to_json(worksheet);
      console.log("Imported Data:", jsonData);

      if (onImportData) onImportData(jsonData);
    };

    reader.readAsArrayBuffer(file);
    // Clear input so the same file can be re-uploaded if needed
    event.target.value = "";
  };

  return (
    <div>
      <TransaparentButton
        text="Import"
        endIcon={<Icon>download</Icon>}
        onClick={handleButtonClick}
      />
      <input
        type="file"
        accept=".xlsx, .xls"
        ref={fileInputRef}
        onChange={handleImportFile}
        style={{ display: "none" }}
      />
    </div>
  );
};

export default ExcelImporter;
